module.exports = __webpack_public_path__ + "static/img/img05.9176219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv027/sp/img05.png
// module id = x9In
// module chunks = 0